import {ApDynformsConfigBase, ApDynformsControltype} from './ap-dynforms-config-base';
import {ApDynformsValidator}                         from '../ap-dynforms-validator';
import {AsyncValidatorFn, ValidatorFn}               from '@angular/forms';

/**
 * configuration for label with icon control
 */
export class ApDynformsConfigLabelIcon extends ApDynformsConfigBase<any> {
  controlType = ApDynformsControltype.LabelIcon;
  src: string;
  srcWidth: number;
  srcHeight: number;
  label1: string;
  label2: string;
  text1: string;
  text2: string;
  highlight: boolean;
  rightToLeft: boolean;

  constructor(options: {
    data_cy?: string,
    key?: string,
    src?: any,
    src_width?: number,
    src_height?: number,
    label1?: string,
    label2?: string,
    text1?: string,
    text2?: string,
    validators?: ApDynformsValidator<ValidatorFn>[],
    asyncValidators?: ApDynformsValidator<AsyncValidatorFn>[],
    highlight?: boolean,
    right_to_left?: boolean,
  } = {}) {
    super(options);
    this.rightToLeft = options.right_to_left || false;
    this.highlight = options.highlight || false;
    this.dataCy = options.data_cy || '';
    this.src = options.src || '';
    this.srcWidth = options.src_width || 50;
    this.srcHeight = options.src_height || 50;
    this.label1 = options.label1 || '';
    this.label2 = options.label2 || '';
    this.text1 = options.text1 || '';
    this.text2 = options.text2 || '';
  }
}
